import { IRentalReport } from '@/services/types/owner';

export function getOwnerListings(
  reports: IRentalReport[] | undefined,
  isOwner: boolean | undefined,
): {
  publishedListings: number;
  unpublishedListings: number;
} {
  if (!reports || !reports.length || !isOwner) {
    return { publishedListings: 0, unpublishedListings: 0 };
  }

  const publishedListings = reports.filter(a => a.published === true).length;
  const unpublishedListings = Math.abs(reports.length - publishedListings);

  return { publishedListings, unpublishedListings };
}
